export function authorize(): string {
	return "/authorize"
}
